<template>
  <div>
    <list-page-header />
    <yv-index
      v-if="isInitComponent"
      :path="path"
      :formSearch="isRoleTeacher ? formSearchTeacher : formSearch"
      :enableExport="false"
      :columns="columns"
      :tableActionsComponent="TableActions"
      :sortable="sortable"
      :formatTableData="formatTableData"
      :additional-params="paramsProps"
      mainField="full_name"
      ref="termsTable"
    >
    </yv-index>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths, service_names } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import { Message, genErrMsgOj, getId } from "@/helpers/utils";
import Swal from "sweetalert2";
import { DEFAULT_OPTION_ALL } from "@/constants";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";

export default {
  name: "ListPage",
  components: {
    YvIndex,
    ListPageHeader: Header
  },
  data() {
    const baseFormSearch = [
      {
        label: "zoom_meeting.title",
        name: "title__~",
        value: "",
        type: "input"
      },
      {
        label: "zoom_meeting.type",
        name: "zoom_meeting_type__eq",
        value: "",
        type: "select",
        options: [
          ...DEFAULT_OPTION_ALL,
          {
            id: "A schedule meeting",
            name: this.$t("zoom_meeting.scheduled_meeting")
          },
          {
            id: "A recurring meeting with fixed time",
            name: this.$t("zoom_meeting.recurring_meeting")
          }
        ]
      },
      {
        label: this.$t("schedule.filter_by_class"),
        name: "class_id",
        value: "",
        displayValue: "",
        options: [],
        type: "autocomplete",
        fields: {
          text: "name",
          value: "id"
        },
        searchKey: "name__~",
        refetchOptions: this.getClassOpts,
        width: 25
      }
    ];
    return {
      path: `${service_names.school}/zoom-meeting`,
      TableActions,
      formData: {},
      serverValidations: {},
      paramsProps: {
        fields: ["full_name", "email"]
      },
      formSearch: [
        ...baseFormSearch,
        {
          label: this.$t("zoom_meeting.host_full_name_email"),
          name: "search_key",
          value: "",
          type: "input",
          width: 35
        }
      ],
      formSearchTeacher: [...baseFormSearch],
      isInitComponent: false,
      isCreate: true,
      columns: {
        title: "zoom_meeting.title",
        zoom_meeting_type: "zoom_meeting.type",
        duration: "zoom_meeting.duration",
        host_fullname: "zoom_meeting.host_fullname",
        host_email: "zoom_meeting.host_email"
      },
      sortable: ["title", "zoom_meeting_type", "duration"]
    };
  },
  computed: {
    ...mapGetters("user", ["role", "info"]),
    isRoleTeacher() {
      return hasValidRole(this.role, Role.Teacher);
    }
  },
  created() {
    this.getClassOpts();
  },
  methods: {
    getClassOpts(queryObj) {
      const userId = getId(this.info);
      let path = this.isRoleTeacher
        ? `${service_names.user}/users/${userId}/classes`
        : `${service_paths.classes}`;

      return this.$axios
        .get(
          path,
          { ...queryObj, status: "" },
          undefined,
          undefined,
          undefined,
          undefined,
          this.isCreate
        )
        .then(response => {
          let options = [];
          this.isCreate = false;
          response.data.data.forEach(classObj => {
            options.push({ id: getId(classObj), name: classObj.name });
          });
          this.formSearch[2].options = options;
          this.formSearchTeacher[2].options = options;
          this.isInitComponent = true;
        });
    },
    formatTableData(tableData) {
      return tableData.map(item => {
        return {
          ...item,
          title: `<p class="w-48">${item.title}</p>`,
          type: `<p class="w-32">${item.type}</p>`,
          host_fullname: `<p class="w-40">${item?.host_zoom_meeting?.host?.full_name}</p>`,
          host_email: item?.host_zoom_meeting?.host?.email
        };
      });
    },
    reFetchTableData() {
      return this.$refs.termsTable.getTableData();
    },
    //delete
    deleteZoomMeeting(data) {
      this.$axios
        .delete(`${service_names.school}/zoom-meeting/${getId(data)}`)
        .then(() => {
          Message.success(this.$t("common.delete_success"));
          this.reFetchTableData();
        });
    },
    confirmDelete(data) {
      if (data.zoom_meeting_type === "A schedule meeting") {
        Swal.fire({
          title: this.$t("common.confirmation"),
          text: this.$t("zoom_meeting.cancel_virtual_meeting"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-danger btn-fill",
          cancelButtonClass: "md-button btn-fill",
          confirmButtonText: this.$t("common.delete"),
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteZoomMeeting(data);
          }
        });
      } else {
        Swal.fire({
          title: this.$t("common.confirmation"),
          text: this.$t("zoom_meeting.are_you_sure_to_cancel"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button btn-fill",
          confirmButtonText: this.$t("common.yes_delete_it"),
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteZoomMeeting(data);
          }
        });
      }
    }
  },
  provide() {
    return {
      confirmDelete: this.confirmDelete,
      reFetchTableData: this.reFetchTableData
    };
  }
};
</script>

<style scoped lang="scss">
.md-button {
  border-radius: 100px !important;
}
</style>
